export const IMGIX_CATEGORY_PLP_PAGE_IMAGE_WIDTH = 32;
export const IMGIX_CATEGORY_PLP_PAGE_IMAGE_HEIGHT = 36;
export const IMGIX_CATEGORY_FILTER_SEARCH_RESULT_PAGE_IMAGE_WIDTH = 32;
export const IMGIX_CATEGORY_FILTER_SEARCH_RESULT_PAGE_IMAGE_HEIGHT = 32;
